import { CommerceShipConnectorsActionTypes } from './constants';

type CommerceShipConnectorsAction = { type: string, payload: {} | string };

export const commerceShipConnectorsApiResponseSuccess = (actionType: string, data: any): CommerceShipConnectorsAction => ({
    type: CommerceShipConnectorsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const commerceShipConnectorsApiResponseError = (actionType, error) => ({
    type: CommerceShipConnectorsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const commerceShipConnectorsCreateShopifyIntegrationAndStartOAuth = (shopifyIntegration) => ({
    type: CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST,
    payload: { shopifyIntegration },
});
